<template>
  <div id="dituContent"></div>
</template>

<script>
import { Options, Vue } from "vue-class-component";
import { MP } from "../utils/map.js";
const tk = "39e180334977d46392be7d15e00c317b";

@Options({
  components: {},
  data() {
    return {
      showBg: true,
    };
  },
  methods: {
    createMap() {
      var T = window.T;
      var map = new T.Map("dituContent");

      // 旭辉·浦江国际3号楼坐标 (GCJ02)
      var lng = 121.5096;
      var lat = 31.0790;

      var point = new T.LngLat(lng, lat);
      map.centerAndZoom(point, 17);

      // 添加缩放控件
      var zoomControl = new T.Control.Zoom();
      map.addControl(zoomControl);

      // 添加比例尺控件
      var scaleControl = new T.Control.Scale();
      map.addControl(scaleControl);

      // 自定义图标标注
      var icon = new T.Icon({
        iconUrl: "https://websiteimg.gnso.cn/index/gns.png",
        iconSize: new T.Point(144, 66),
        iconAnchor: new T.Point(72, 33),
      });
      var marker = new T.Marker(point, {
        icon: icon,
      });
      map.addOverLay(marker);
    },
  },
  mounted() {
    this.$nextTick(() => {
      MP(tk)
        .then(() => {
          this.createMap();
        })
        .catch((error) => {
          console.log(error);
        });
    });
  },
})
export default class ThirdMap extends Vue {}
</script>

<style scoped lang="scss">
#dituContent {
  width: 100%;
  height: 500px;
  border: #ccc solid 1px;
}
</style>
